"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var FormGroup = function FormGroup(_ref) {
  var name = _ref.name,
      label = _ref.label,
      error = _ref.error,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["name", "label", "error", "children"]);
  return /*#__PURE__*/_react["default"].createElement("div", rest, /*#__PURE__*/_react["default"].createElement("label", {
    className: "block mb-3 text-xs uppercase font-semibold"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('p-3 border mb-3 h-12', {
      'border-red': error
    })
  }, children), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-red text-xs', {
      invisible: !error
    })
  }, !!error ? error : 'No errors'));
};

var _default = FormGroup;
exports["default"] = _default;
//# sourceMappingURL=FormGroup.js.map